import React from 'react'
import { observer } from 'mobx-react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

import Typography from '../../UniformComponents/Typography'
import PreviewSlide from './PreviewSlide'

const SlidePreview = ({ store }) => {
    const {
        onSlideDragEnd, changeCurrentSlide, currentSlide, currentSection, sections,
    } = store

    return (
        <div className="pp-slide-preview-container">
            <div className="pp-slides-section-container">
                <DragDropContext onDragEnd={onSlideDragEnd}>
                    {sections
                        .map((section, i) => (
                            <div className="pp-slides-section-content">
                                <Typography type="b">
                                    {`Section ${i + 1}`}
                                </Typography>

                                <Droppable droppableId={`slide-list-section-${i}`}>
                                    {(pr) => (
                                        <div
                                            ref={pr.innerRef}
                                            {...pr.droppableProps}
                                            className="pp-slides-preview-container"
                                        >
                                            {section.slide
                                                .map((slide, index) => (
                                                    <Draggable
                                                        key={slide.id}
                                                        draggableId={slide.id}
                                                        index={index}
                                                        id={slide.id}
                                                    >
                                                        {(provided) => (
                                                            <div
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                            >
                                                                <div style={{ display: 'flex', gap: 5, justifyContent: 'space-between' }}>
                                                                    <div style={{ width: 15 }}>
                                                                        <Typography type="tiny">{index + 1}</Typography>
                                                                    </div>

                                                                    <PreviewSlide
                                                                        isActive={currentSlide === index && currentSection === i}
                                                                        changeSlide={() => changeCurrentSlide(i, index)}
                                                                        slide={slide}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                ))}
                                        </div>
                                    )}
                                </Droppable>
                            </div>
                        ))}
                </DragDropContext>
            </div>
        </div>
    )
}

export default observer(SlidePreview)
